import { ReactNode } from 'react';
import { motion } from 'framer-motion';

type AccordionProps = {
  isOpen: boolean;
  initialHeight?: number;
  children: ReactNode;
};

const Accordion = ({ isOpen, initialHeight, children }: AccordionProps) => {
  const animate = {
    transition: { type: 'tween' },
    height: isOpen ? 'auto' : initialHeight ? initialHeight : 0
  };

  return (
    <motion.div
      style={{ overflow: 'hidden', padding: '0', cursor: 'pointer' }}
      initial={{ height: initialHeight ? initialHeight : 0, opacity: 1 }}
      animate={animate}
      exit={{ height: initialHeight ? initialHeight : 0, opacity: 1 }}
    >
      {children}
    </motion.div>
  );
};

export default Accordion;
